import API from '@/amplify/api';
import { selector } from 'recoil';
import { getListAllProjectOfUser, getProjectById, getProjectIdListUserIsB2C, getProjectUserInUseDetail } from '@/service/projectService';
import localStorageUtil from '@/common/utils/localStorageUtil';
import Utils, { sortListByNameDictionaryASC } from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { projectInuseDetailAtom } from '../atom/projectAtom';
import { getUserById } from '@/service/userService';


/**
 * Check isManager by projectInuse selector
 * params: projectId, userId
 */
export const isManagerByProjectInuseSelector = selector({
    key: 'isManagerByProjectInuseSelector',
    get: async ({ get }) => {
        try {
            // get userId, projectInuseId from localstoragae
            let userId = localStorageUtil.getUserDetailId();
            let projectInuseDetail = get(projectInuseDetailAtom);
            if (!userId || !projectInuseDetail?.id) return false;

            let projectDetail = await getProjectUserInUseDetail(API, userId, projectInuseDetail?.id);
            const isManagerByPrjInuse = !Utils.isEmptyObject(projectDetail) && projectDetail.privilege === Constant.PRIVILEGE_PROJECT.PRJ_MGR;
            return isManagerByPrjInuse;
        } catch (err) {
            console.log('isManagerByProjectInuseSelector err', err);
            return false;
        }
    },
    cachePolicy_UNSTABLE: {
        // Only store the most recent set of dependencies and their values
        eviction: 'most-recent',
    },
});

/**
 * Get project list in corporation by userId selector
 */
export const getProjectListInCorporationByUserIdSelector = selector({
    key: 'getProjectListInCorporationByUserId',
    get: async ({ get }) => {
        try {
            let corporationId = localStorageUtil.getAffiliationOrganization();
            let userId = localStorageUtil.getUserDetailId();
            let projectList = await getListAllProjectOfUser(API, corporationId, userId);
            return sortListByNameDictionaryASC(projectList);
        } catch (err) {
            console.error(`getProjectListInCorporationByUserId error: ${err}`);
            return [];
        }
    },
    cachePolicy_UNSTABLE: {
        // Only store the most recent set of dependencies and their values
        eviction: 'most-recent',
    },
});

/**
 * Get projectInuse detail selector
 */
export const getProjectInuseDetailSelector = selector({
    key: 'getProjectInuseDetailSelector',
    get: async ({ get }) => {
        try {
            let userId = localStorageUtil.getUserDetailId();
            let userDetail = await getUserById(API, userId);

            let projectInuseId = userDetail.projectInuse;

            let [projectDetail, userInProjects] = await Promise.all([
                getProjectById(API, projectInuseId),
                getProjectUserInUseDetail(API, userId, projectInuseId) // check manager user
            ]);
            projectDetail.isProjectManager = userInProjects?.privilege === Constant.PRIVILEGE_PROJECT.PRJ_MGR;
            localStorageUtil.setSelectedProjectId(projectDetail.id);
            localStorageUtil.setSelectedProjectType(projectDetail.type);
            return projectDetail;
        } catch (err) {
            console.log('getProjectInuseDetailSelector err :>> ', err);
            return {};
        }
    },
    cachePolicy_UNSTABLE: {
        // Only store the most recent set of dependencies and their values
        eviction: 'most-recent',
    },
});


export const getProjectIdListUserIsB2CAtomSelector = selector({
    key: 'getProjectIdListUserIsB2CAtomSelector',
    get: async ({ get }) => {
        try {
            let userId = localStorageUtil.getUserDetailId();
            let projectList = await getProjectIdListUserIsB2C(API, userId);
            return projectList;
        } catch (err) {
            console.log('getProjectIdListUserIsB2CAtomSelector err:', err);
            return [];
        }
    },
    cachePolicy_UNSTABLE: {
        // Only store the most recent set of dependencies and their values
        eviction: 'most-recent',
    },
});

export const getViewKnowledgeProjectSelectedSelector = selector({
    key: 'getViewKnowledgeProjectSelectedSelector',
    get: async({get}) => {
        try {
            const projectId = localStorageUtil.getSelectedProjectId()
            const corporationDetail = get(corporationAtom);

            return {
                projectId: projectId,
                corporationId: corporationDetail.id,
                inviter: corporationDetail.inviter || ''
            }
        } catch (error) {
            console.log('getViewKnowledgeProjectSelectedSelector error >>>', error)
            return {}
        }
    },
    cachePolicy_UNSTABLE: {
        eviction: 'most-recent',
    },
})